<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a" id="contents"><a id="page_v"></a><span class="small">CONTENTS</span></h2>
<p class="toc"><a class="nounder" href="#/xhtml/preface"><em>Preface</em></a></p>
<p class="toc"><a class="nounder" href="#/xhtml/introduction">Introduction: The Problem with History</a></p>
<p class="toc1"><a class="nounder" href="#/xhtml/ch01">1. History and Religion</a></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch02" title="Link target outside of Sample">2. History and Philosophy</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch03" title="Link target outside of Sample">3. History and the Social Sciences</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch04" title="Link target outside of Sample">4. History and Literature</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch05" title="Link target outside of Sample">5. History and Biography</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch06" title="Link target outside of Sample">6. History and Policy Studies</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch07" title="Link target outside of Sample">7. History and the Law</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/conclusion" title="Link target outside of Sample">Conclusion: An Answer?</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/notes" title="Link target outside of Sample"><em>Notes</em></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/app01" title="Link target outside of Sample"><em>A Very Short Bibliography (with Annotations)</em></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/index" title="Link target outside of Sample"><em>Index</em></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/app02" title="Link target outside of Sample"><em>About the Author</em></span></p>
<p class="noindent"><a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?51f54ce4